import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div className="text-center">
        <h1 className="text-7xl font-bold text-red-600">404</h1>
        <p className="mt-4 text-xl text-gray-700">Page Not Found</p>
        <p className="mt-2 text-gray-500">The page you're looking for doesn't exist.</p>
        <button
          onClick={handleGoBack}
          className="mt-6 px-4 py-2 bg-active text-active-foreground rounded hover:bg-secondary" >
          <span className="mr-2 text-xl">&#8592;</span> Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFound;
